import isElementManuallyBlocked from 'utils/isElementManuallyBlocked'

const BLOCKED_SELECTOR = '[data-categories]'


/**
 * @param {Element} root
 *
 * @returns {Element[]} every manually-marked element at or beneath `root`
 */
export default function findBlockedElements(root) {
  const elements = Array.from(root.querySelectorAll(BLOCKED_SELECTOR))

  // `querySelectorAll()` only looks downward, and a single-page app hands us
  // the blocked tag itself about as often as it hands us a container holding
  // one.
  if ( root.matches(BLOCKED_SELECTOR) ) {
    elements.unshift(root)
  }

  return elements.filter(isElementManuallyBlocked)
}
